import React from "react";
import { useLanguage } from "../../../../contexts/LanguageContext";

export function PosterHeader() {
  const { t } = useLanguage();
  const logoUrl = process.env.PUBLIC_URL
    ? `${process.env.PUBLIC_URL}/logojes.png`
    : "/logojes.png";

  return (
    <div className="flex items-center justify-between flex-shrink-0 mb-2">
      <img src={logoUrl} alt="JesCook" className="h-7 w-auto object-contain" />
      <span className="text-[9px] font-medium text-white/70 uppercase tracking-widest leading-relaxed">
        {t("posterGeneratedBy")}
      </span>
    </div>
  );
}
